import ConfirmModal from "./confrim_modal";
export default ConfirmModal;
